export const url = 'https://react-rslang-be-production-97d9.up.railway.app';

export const path = {
  words: `${url}/words`,
  users: `${url}/users`,
  signIn: `${url}/signin`,
};
